import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/help',
    name: 'HelpView',
    component: () => import('../views/HelpStart.vue')
  },
  {
    path: '/help/connector',
    name: 'HelpView',
    component: () => import('../views/HelpView.vue')
  },
  {
    path: '/jsondata',
    name: 'JsonDataView',
    component: () => import('../views/JsonDataView.vue')
  },
  {
    path: '/remoteservices',
    name: 'RemoteServiceList',
    component: () => import('../views/digitalfirm/RemoteServiceList.vue')
  },
  {
    path: '/remoteservices/:id',
    name: 'RemoteServiceEditor',
    component: () => import('../views/digitalfirm/RemoteServiceEditor.vue')
  },
  {
    path: '/servicerequests',
    name: 'ServiceRequestList',
    component: () => import('../views/services/ServiceRequestList.vue')
  },
  {
    path: '/servicerequests/:id',
    name: 'ServiceRequestView',
    component: () => import('../views/services/ServiceRequestView.vue')
  },
  {
    path: '/servicetemplates',
    name: 'ServiceTemplateList',
    component: () => import('../views/services/ServiceTemplateList.vue')
  },
  {
    path: '/servicetemplates/:tid',
    name: 'ServiceTemplateEditor',
    component: () => import('../views/services/ServiceTemplateEditor.vue')
  },
  {
    path: '/tasklist',
    name: 'TaskList',
    component: () => import('../views/services/TaskList.vue')
  },
  {
    path: '/tasklist/:taskid',
    name: 'TaskFormView',
    component: () => import('../views/services/TaskFormView.vue')
  },
  {
    path: '/giftcards/',
    name: 'GiftCardList',
    component: () => import('../views/digitalfirm/giftcards/GiftCardList.vue')
  },
  {
    path: '/giftcards/:id',
    name: 'GiftCardEditor',
    component: () => import('../views/digitalfirm/giftcards/GiftCardEditor.vue')
  },
  {
    path: '/offers',
    name: 'OfferList',
    component: () => import('../views/documents/OfferListView.vue')
  },
  {
    path: '/offers/:offerid',
    name: 'OfferView',
    component: () => import('../views/documents/OfferView.vue')
  },
  {
    path: '/orders',
    name: 'OrderList',
    component: () => import('../views/documents/OrderListView.vue')
  },
  {
    path: '/orders/:orderid',
    name: 'OrderView',
    component: () => import('../views/documents/OrderView.vue')
  },
  {
    path: '/delivernotes',
    name: 'DeliveryNotes',
    component: () => import('../views/documents/DeliveryNoteListView.vue')
  },
  {
    path: '/delivernotes/:noteid',
    name: 'DeliveryNoteView',
    component: () => import('../views/documents/DeliveryNoteView.vue')
  },
  {
    path: '/inventories',
    name: 'InventoryList',
    component: () => import('../views/documents/InventoryListView.vue')
  },
  {
    path: '/inventories/:invid',
    name: 'InventoryView',
    component: () => import('../views/documents/InventoryView.vue')
  },
  {
    path: '/customers',
    name: 'CustomerList',
    component: () => import('../views/customers/CustomerList.vue')
  },
  {
    path: '/customers/:customerid',
    name: 'CustomerView',
    component: () => import('../views/customers/CustomerView.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/reports/Dashboard.vue')
  },
  {
    path: '/reports',
    name: 'ReportList',
    component: () => import('../views/reports/ReportList.vue')
  },
  {
    path: '/reports/:reportid/',
    name: 'ReportEditor',
    component: () => import('../views/reports/ReportEditor.vue')
  },
  {
    path: '/chatbot',
    name: 'ChatBotConfig',
    component: () => import('../views/digitalfirm/ChatBotConfig.vue')
  },
  {
    path: '/pdfcatalogs',
    name: 'PDFCatalogs',
    component: () => import('../views/digitalfirm/PDFCatalogs.vue')
  },
  {
    path: '/rules',
    name: 'RulesEditor',
    component: () => import('../views/digitalfirm/RulesEditor.vue')
  },
  {
    path: '/events',
    name: 'EventManageView',
    component: () => import('../views/digitalfirm/EventManageView.vue')
  },
  {
    path: '/scripttasks',
    name: 'ScriptTaskList',
    component: () => import('../views/digitalfirm/ScriptTaskList.vue')
  },
  {
    path: '/scripttasks/:scriptid',
    name: 'ScriptTaskEditor',
    component: () => import('../views/digitalfirm/ScriptTaskEditor.vue')
  },
  {
    path: '/workflows',
    name: 'ProcessOverview',
    component: () => import('../views/digitalfirm/workflows/ProcessOverview.vue')
  },
  {
    path: '/workflows/definitions/:defid',
    name: 'ProcessDefinition',
    component: () => import('../views/digitalfirm/workflows/ProcessDefinition.vue')
  },
  {
    path: '/workflows/history/:id',
    name: 'ProcessHistoryEntry',
    component: () => import('../views/digitalfirm/workflows/ProcessHistoryEntry.vue')
  },
  {
    path: '/workflows/editor/:defid',
    name: 'ProcessEditor',
    component: () => import('../views/digitalfirm/workflows/ProcessEditor.vue')
  },
  {
    path: '/bflows',
    name: 'BusinessFlows',
    component: () => import('../views/digitalfirm/BusinessFlows.vue')
  },
  {
    path: '/bflows/editor/:flowid',
    name: 'BFlowEditor',
    component: () => import('../views/digitalfirm/BFlowEditor.vue')
  },
  {
    path: '/datamap',
    name: 'DataMapOverview',
    component: () => import('../views/datamap/DataMapOverview.vue')
  },
  {
    path: '/datamap/sources',
    name: 'DataSourcesView',
    component: () => import('../views/datamap/DataSourcesView.vue')
  },
  {
    path: '/datamap/tables',
    name: 'DataTablesView',
    component: () => import('../views/datamap/DataTablesView.vue')
  },
  {
    path: '/datamap/tables/:name',
    name: 'DataTableEditor',
    component: () => import('../views/datamap/DataTableEditorView.vue')
  },
  {
    path: '/config',
    name: 'ConfigView',
    component: () => import('../views/admin/ConfigView.vue')
  },
  {
    path: '/config/firm',
    name: 'FirmConfigView',
    component: () => import('../views/admin/FirmConfigView.vue')
  },
  {
    path: '/mailtemplates',
    name: 'EMailTemplates',
    component: () => import('../views/admin/EMailTemplates.vue')
  },
  {
    path: '/extrafields/:type',
    name: 'iHandExtraFields',
    component: () => import('../views/admin/iHandExtraFields.vue')
  },
  {
    path: '/datasync',
    name: 'DataSyncControl',
    component: () => import('../views/admin/DataSyncControl.vue')
  },
  {
    path: '/databackup',
    name: 'DataBackup',
    component: () => import('../views/admin/DataBackupView.vue')
  },
  {
    path: '/modules',
    name: 'ModulesOverview',
    component: () => import('../views/admin/modules/ModulesOverview.vue')
  },
  {
    path: '/modules/admin/',
    name: 'ModulesAdmin',
    component: () => import('../views/admin/modules/ModulesAdmin.vue')
  },
  {
    path: '/modules/upload/:mid',
    name: 'ModuleUpload',
    component: () => import('../views/admin/modules/ModuleUpload.vue')
  },
  {
    path: '/sysuser',
    name: 'UserList',
    component: () => import('../views/admin/UserList.vue')
  },
  {
    path: '/ihanduser',
    name: 'iHandUserList',
    component: () => import('../views/admin/iHandUserList.vue')
  },
  {
    path: '/ihanduser/:userid',
    name: 'iHandUserEditor',
    component: () => import('../views/admin/iHandUserEditor.vue')
  },
  {
    path: '/sysuser/:userid',
    name: 'UserEditor',
    component: () => import('../views/admin/UserEditor.vue')
  },
  {
    path: '/categories',
    name: 'CategoryTree',
    component: () => import('../views/articles/CategoryTree.vue')
  },
  {
    path: '/articles/:articleid',
    name: 'ArticleView',
    component: () => import('../views/articles/ArticleView.vue')
  },
  {
    path: '/articles',
    name: 'ArticleList',
    component: () => import('../views/articles/ArticleList.vue')
  },
  {
    path: '/articleselection',
    name: 'ArticleSelectionList',
    component:  () => import('../views/articles/ArticleSelectionList.vue')
  },
  {
    path: '/passwords',
    name: 'PasswordStore',
    component: () => import('../views/digitalfirm/PasswordStore.vue')
  },
  {
    path: '/ui/manager/:area',
    name: 'CMSUIManager',
    component: () => import('../views/digitalfirm/cms/UIManager.vue')
  },
  {
    path: '/ui/resources/:area',
    name: 'CMSResourceManager',
    component: () => import('../views/digitalfirm/cms/ResourceManager.vue')
  },
  {
    path: '/ui/components/:area',
    name: 'CMSComponentManager',
    component: () => import('../views/digitalfirm/cms/ComponentManager.vue')
  },
  {
    path: '/ui/editor/:tree/:catid/:docid',
    name: 'CMSPageEditor',
    component: () => import('../views/digitalfirm/cms/CMSPageEditor.vue')
  },
  {
    path: '/ui/mailmanager/',
    name: 'CMSMailManager',
    component: () => import('../views/digitalfirm/cms/CMSMailManager.vue')
  },
  {
    path: '/ui/maileditor/:catid/:docid',
    name: 'CMSMailEditor',
    component: () => import('../views/digitalfirm/cms/CMSMailEditor.vue')
  },
  {
    path: '/tables/',
    name: 'TablesList',
    component: () => import('../views/digitalfirm/tables/TablesList.vue')
  },
  {
    path: '/tables/schema/:id',
    name: 'TableSchemaEditor',
    component: () => import('../views/digitalfirm/tables/TableSchemaEditor.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
